module.exports = __webpack_public_path__ + "img/type--4-spans--single-lang--de.5f48c27f.jpg";